import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import {
  IWorksheetComponent,
  WorksheetAssociatedTestSection,
  WorksheetBalanceFieldSet,
} from 'Components/Worksheets/Core';
import { AssociatedTestType } from 'Components/Worksheets/Core/WorksheetAssociatedTestSection/types';
import ExternalTestMethods from 'Components/Worksheets/ExternalTestMethods';
import { Guid } from 'Lib/Guid';
import React from 'react';
import { useSelector } from 'react-redux';

let SievePortionPreparationSectionDryingBeforeSeparationWithMoist: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  const importedMoistureContentId: Guid = useSelector(
    createWorksheetSelector!('AssociatedMoistureContent.ImportedTest.Id')
  );

  return (
    <>
      <NamePrefixModifier appendNamePrefix="MassMeasurement">
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
          <Field input={<NumericInput />} name="TareMass" />
          <Field input={<NumericInput />} name="TareAndWetMass" />
          <Field input={<TextOutput />} name="WetMass" />
        </ListFieldSection>
      </NamePrefixModifier>
      <ListFieldSection heading="Sieve Portion Dry Mass" wide>
        <WorksheetAssociatedTestSection
          name="AssociatedMoistureContent"
          heading={'Sieve Portion Dry Mass'}
          label={'Whole Material Moisture Content Determined By'}
          testType="Moisture Content"
          defaultSelection={AssociatedTestType.AutoImported}
          associatedTestModel={{
            measured: true,
            autoImported: true,
            imported: {
              importedTestResults: (
                <ListFieldSection>
                  <Field input={<TextOutput />} name="MoistureContent" emph />
                </ListFieldSection>
              ),
              importModel: {
                Id: importedMoistureContentId,
              },
            },
            external: {
              testMethods: [
                ExternalTestMethods.moistureContent.AS_1289_2_1_1,
                ExternalTestMethods.moistureContent.AS_1289_2_1_6,
              ],
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    name="AssociatedMoistureContent.ExternalTest.Results.MoistureContentPercent"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} name="DryMass" />
      </ListFieldSection>
    </>
  );
};

SievePortionPreparationSectionDryingBeforeSeparationWithMoist = withInjectedProps(
  SievePortionPreparationSectionDryingBeforeSeparationWithMoist
);

export { SievePortionPreparationSectionDryingBeforeSeparationWithMoist };
export default SievePortionPreparationSectionDryingBeforeSeparationWithMoist;
